<!--  -->
<template>
  <div>
    <!-- 导航栏  #left-->
    <van-nav-bar title="编辑职位描述" fixed placeholder z-index="10" @click-left="goBack">
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>

    <div class="edit-boxs">
      <div class="edit-item">
        <van-field
          v-model="message"
          rows="5"
          autosize
          type="textarea"
          maxlength="400"
          placeholder="描述你在该公司的主要工作内容"
          show-word-limit
        />
      </div>
    </div>
    <div class="btn">
      <button class="clear" @click="deletes">删除</button>
      <button class="confirm" @click="savePosition">保存</button>
    </div>
  </div>
</template>

<script>
import {Dialog } from 'vant'
export default {
  components: {},
  data() {
    return {
      message: ""
    };
  },
  computed: {},
  methods: {
    goBack() {
      this.$router.replace({
         name: "EditPosition",
        // query: {
        //   descript: this.message
        // }
      });
    },
    // 删除
    deletes() {
     Dialog.confirm({
  title: '提示',
  message: '确认删除吗?',
})
  .then(() => {
   this.message=''
   this.$router.replace({
     name: "EditPosition",
        query: {
          descript: this.message
        }
   })
  })
  .catch(() => {
    // on cancel
  });
    },
    // 保存
    savePosition() {
      this.$router.replace({
        name: "EditPosition",
        query: {
          descript: this.message
        }
      });
    }
  },

  created() {
    //(this.$route.query.descript.length);
    
    if(this.$route.query.descript.length>0){
      this.message=this.$route.query.descript
    }
  },
  mounted() {}
};
</script>
<style lang='less' scoped>
/deep/.van-field__control::-webkit-input-placeholder {
  font-weight: 400;
  line-height: 0.42rem;
  font-size: 0.3rem;
  color: rgba(204, 204, 204, 1);
}
.van-cell {
  padding: 0.1rem 0;
}
.edit-boxs {
  padding: 0 0.32rem;
  .edit-item {
    padding: 0.36rem 0 0;
    border-bottom: 0.01rem solid rgba(229, 229, 229, 1);
    //   p {
    //     font-size: 0.26rem;
    //     font-weight: 400;
    //     line-height: 0.37rem;
    //     color: rgba(128, 128, 128, 1);
    //   }
  }
}
</style>